<div class="iq-sidebar">
  <div class="iq-sidebar-logo">
    <a routerLink="/dashboard">
      <div class="topsidelogo">
        <h1>All Out: Vendor Panel</h1>
      </div>
    </a>
  </div>
  <div id="sidebar-scrollbar">
    <nav class="iq-sidebar-menu">
      <ul id="iq-sidebar-toggle" class="iq-menu">
        <li [ngClass]="{ 'active main-active': dashboard.isActive }">
          <a class="iq-waves-effect" routerLink="/dashboard" routerLinkActive #dashboard="routerLinkActive"
            [routerLinkActiveOptions]="{exact: true}">

            <i class="ri-hospital-fill"></i><span>Dashboard</span>

          </a>
        </li>


        <li [ngClass]="{ 'active main-active': bookings.isActive }">
          <a class="iq-waves-effect" routerLink="/bookings" routerLinkActive #bookings="routerLinkActive"
            [routerLinkActiveOptions]="{exact: true}">

            <i class="fa fa-calendar"></i>
            <span>Manage Booking</span>

          </a>
        </li>
        <li [ngClass]="{ 'active main-active': comboBooking.isActive }">
          <a class="iq-waves-effect" routerLink="/combo-booking" routerLinkActive #comboBooking="routerLinkActive"
            [routerLinkActiveOptions]="{exact: true}">

            <i class="fa fa-calendar"></i>
            <span>Manage Combo Booking</span>

          </a>
        </li>
        <li [ngClass]="{ 'active main-active': refundManagement.isActive }">
          <a class="iq-waves-effect" routerLink="/refund-management" routerLinkActive #refundManagement="routerLinkActive"
            [routerLinkActiveOptions]="{exact: true}">

            <i class="fa fa-calendar"></i>
            <span>Refund Management</span>

          </a>
        </li>
        <li [ngClass]="{ 'active main-active': manageCustomer.isActive }">
          <a class="iq-waves-effect" routerLink="/manage-customers" routerLinkActive #manageCustomer="routerLinkActive"
            [routerLinkActiveOptions]="{exact: true}">

            <i class="ri-user-3-fill"></i>
            <span>Manage Customers</span>

          </a>
        </li>
        <li>

          <a href="#datamanagement" class="iq-waves-effect collapsed"
            data-toggle="collapse" [attr.aria-expanded]="dataManagementMainMenu">

            <i class="fa fa-hdd-o"></i>
            <span>Data Management</span>
            <i class="ri-arrow-right-s-line iq-arrow-right"></i>

          </a>

          <ul id="datamanagement" class="iq-submenu collapse" data-parent="#iq-sidebar-toggle"
            [ngClass]="{'show' : dataManagementMainMenu }">


            <li [ngClass]="{ 'active' : dmsm39.isActive || this.updateLocation }">
              <a routerLink="/reporting/list" routerLinkActive #dmsm39="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">

                <i class="ri-user-3-fill"></i><span>Booking Report</span>

              </a>
            </li>


            <li [ngClass]="{ 'active' : dmsm1.isActive || this.updateLocation }">
              <a routerLink="/manage/locations" routerLinkActive #dmsm1="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">

                <i class="ri-user-3-fill"></i><span>Manage Location</span>

              </a>
            </li>

            <li [ngClass]="{ 'active main-active' : dmsm2.isActive }">
              <a routerLink="/manage/locations/add" routerLinkActive #dmsm2="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">

                <i class="fa fa-id-card-o"></i><span>Add Location</span>

              </a>
            </li>

            <li [ngClass]="{ 'active main-active' : dmsm3.isActive }">
              <a routerLink="/manage/services" routerLinkActive #dmsm3="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">

                <i class="fa fa-hdd-o"></i><span>Manage Service</span>

              </a>
            </li>

            <li [ngClass]="{ 'active main-active' : dmsm4.isActive }">
              <a routerLink="/manage/combo-packages" routerLinkActive #dmsm4="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">

                <i class="fa fa-hdd-o"></i><span>Manage Combo Packages</span>

              </a>
            </li>

            <!-- <li [ngClass]="{ 'active' : dmsm2.isActive }">
              <a routerLink="/manage/plans" routerLinkActive #dmsm2="routerLinkActive"
              [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-hdd-o"></i><span>Manage Plans</span>
              </a>
            </li> -->

            <li [ngClass]="{ 'active main-active' : dmsm5.isActive }">
              <a routerLink="/manage/coupons" routerLinkActive #dmsm5="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">

                <i class="fa fa-hdd-o"></i><span>Manage Discount</span>

              </a>
            </li>

          </ul>

        </li>
        <!-- <li>
          <a href="#customers" class="iq-waves-effect collapsed"
            data-toggle="collapse" [attr.aria-expanded]="manageCustomersMainMenu">
            <i class="ri-user-3-fill"></i>
            <span>Manage Customers</span>
            <i class="ri-arrow-right-s-line iq-arrow-right"></i>
          </a>
          <ul id="customers" class="iq-submenu collapse" data-parent="#iq-sidebar-toggle"
            [ngClass]="{ 'show' : manageCustomersMainMenu }">
            <li [ngClass]="{ 'active main-active' : mcsm1.isActive || this.updateCustomer }">
              <a routerLink="/customers" routerLinkActive #mcsm1="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">

                <i class="ri-user-3-fill"></i><span>All Customers</span>

              </a>
            </li>

            <li [ngClass]="{ 'active main-active' : mcsm2.isActive }">
              <a routerLink="customers/add" routerLinkActive #mcsm2="routerLinkActive"
                [routerLinkActiveOptions]="{exact: true}">

                <i class="fa fa-id-card-o"></i><span>Add Customers</span>

              </a>
            </li>

          </ul>
        </li> -->
        <li [ngClass]="{ 'active main-active': complaints.isActive }">
          <a routerLink="/complaints" class="iq-waves-effect" routerLinkActive #complaints="routerLinkActive"
            [routerLinkActiveOptions]="{exact: true}">

            <i class="fa fa-exclamation-circle"></i><span>complaints</span>

          </a>
        </li>
        <li>
          <a href="javascript:void(0);" class="iq-waves-effect" (click)="logout()">
            <i class="fa fa-sign-out"></i><span>Log Out</span>
          </a>
        </li>
      </ul>
    </nav>
    <div class="p-3"></div>
  </div>
</div>
